import { Plugins } from '@leverege/plugin';
import Constants from "./Constants.js";
/**
 * The AggRequestorFactory maps the aggRequestorType to a plugin that contains a 
 * requestAggs( grpObjRef, grouping, context, opts ) call. The Plugin addition should
 * look like: 
 * <pre>
 *   molten.addPlugin( 'Molten.GroupingAggRequestor', { 
 *     type : <aggRequestorType>, 
 *     requestor : {
 *       requestAggs : ( grpObjRef, grouping, context, { dispatch, getState, opts } ) => { }
 *       installUpdater : ( grpObjRef, grouping, context, callback ) => { }
 *     }
 *   } )
 * </pre>
 * 
 * grpObjRef is the objRef of the Groupings. The groupings object is the Grouping's data,
 * the context is given from the aggregation loader (AggLoader, for example) and the options
 * for a redux thunk. 
 */
const AggRequestorFactory = Plugins.createFactory(Constants.AGG_REQUESTOR_PLUGIN_TYPE, {
  pluginKey: 'requestor',
  strategy: Plugins.LOOKUP
});
export default AggRequestorFactory;